import { IOnInit } from "angular";
import { GridConfiguration } from "../../../../../records/views/recordGridView";
import { MachineConfigurationViewThreeRivers } from "../../../models/machineConfiguration";
import {
  ConversionModalService,
  vsServiceName as ConversionModalServiceName,
} from "../../../../shared/components/conversionModal";
import { StateService } from "@uirouter/angularjs";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { vsServiceName as MachineDetailTabsServiceName } from "../../../../shared/components/views/machines/detail/tabs";
import { IQuery } from "../../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../records/server/serverUtility";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../../../ui/authorizedUiElement";
import {
  MachineConfigurationCellClassService,
  vsServiceName as machineConfigurationCellClassServiceName,
} from "../../../../shared/machineConfigurationCellClassService";

export class ThreeRiversMachinesComponentsViewsMainController
  implements IOnInit
{
  /*bindings*/
  gridConfiguration!: GridConfiguration;
  /* end bindings */

  gridSelection: MachineConfigurationViewThreeRivers[] = [];
  includeDecommissioned: boolean = false;
  defaultQuery: IQuery = {
    Statuss: "Floor,Warehoused",
    CurrentConfiguration: true,
  };

  static $inject = [
    ConversionModalServiceName,
    "$state",
    ColumnDefinitionServiceName,
    MachineDetailTabsServiceName,
    ServerUtilityName,
    machineConfigurationCellClassServiceName,
  ];
  constructor(
    private readonly conversionModalService: ConversionModalService,
    private readonly $state: StateService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>,
    private readonly serverUtility: ServerUtility,
    private readonly machineConfigurationCellClass: MachineConfigurationCellClassService
  ) {}

  $onInit(): void {
    this.gridConfiguration.showSelectButtons = true;
    this.gridConfiguration.columns = [
      this.columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression: `${this.machineDetailTabsService.getSrefByIndex(
          0
        )}({ machineId: data.MachineId})`,
        requiresPermission: "machineView",
      }),
      this.columnDefinitionService.getLinkColDef({
        colId: "edit",
        headerName: "edit",
        iconClass: "fa fa-pencil",
        stateExpression:
          "main.machines.detail.edit({ machineId: data.MachineId, machineConfigurationId: data.MachineConfigurationId})",
        requiresPermission: "machineEdit",
      }),
      this.columnDefinitionService.getSelectColDef({ headerName: "select" }),
      ...(this.gridConfiguration.columns ?? []),
    ];
    this.machineConfigurationCellClass.styleColumns(
      this.gridConfiguration.columns,
      false
    );
  }

  gridSelectionChanged(
    data: MachineConfigurationViewThreeRivers,
    selected: boolean,
    selectedIds: number[]
  ) {
    const selectedItems = this.gridSelection;
    if (selected) {
      selectedItems.push(data);
    }
    this.gridSelection = selectedItems.filter((si) =>
      selectedIds.includes(si.Id)
    );
  }

  childDisabled(child: AuthorizedUiElementConfig) {
    const selectedMachines = this.gridSelection.length;
    if (selectedMachines < 2) return false;

    return child.id === "clone" || child.id === "conversion";
  }

  machineConfigurationIdSelector(
    machineView: MachineConfigurationViewThreeRivers
  ) {
    return machineView.MachineConfigurationId;
  }

  childClicked(
    child: AuthorizedUiElementConfig,
    childService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {
    switch (child.id) {
      case "clone":
        const machineId = this.gridSelection[0].MachineId;
        const machineConfigurationId = this.gridSelection[0].Id;
        childService.navigateToChild(child, {
          modelMachineId: machineId,
          modelMachineConfigurationId: machineConfigurationId,
        });
        break;
      case "conversion":
        const selectedMachineConfigurationView = this.gridSelection.at(0)!;
        const modalInstance = this.conversionModalService.openModal();
        modalInstance.result.then((result) => {
          return childService.navigateToChild(child, {
            machineId: selectedMachineConfigurationView.MachineId,
            modelMachineId: result.machineId,
            modelMachineConfigurationId: result.machineConfigurationId,
          });
        });
        break;
      default:
        const sref = childService.getSref(child);
        this.$state.go(sref, {
          machineConfigurations: this.gridSelection,
        });
    }
  }

  downloadExcel() {
    this.serverUtility
      .sendApiRequest<Blob>({
        method: "post",
        url: "/api/machines/Machine/excel",
        data: {
          query: {
            ...this.gridConfiguration.gridDataSource!.query,
            CurrentConfiguration: true,
          },
        },
        responseType: "blob",
      })
      .then((r) => {
        this.serverUtility.saveFile({ content: r, filename: "machines.xlsx" });
      });
  }

  includeDecommissionedChanged(includeDecommissioned: boolean) {
    if (includeDecommissioned) {
      this.defaultQuery.Statuss = undefined;
    } else {
      this.defaultQuery.Statuss = "Warehoused,Floor";
    }
  }

  showAllConfigurationsChanged(showAllConfigurations: boolean) {
    if (showAllConfigurations) {
      this.defaultQuery.CurrentConfiguration = undefined;
    } else {
      this.defaultQuery.CurrentConfiguration = true;
    }

    this.machineConfigurationCellClass.styleColumns(
      this.gridConfiguration.columns,
      showAllConfigurations
    );
  }
}
